import React, { Fragment } from 'react'
import { NextSeo } from 'next-seo'

import { withAuthPage } from '../components/withAuthPage'
import { SignUpLayout } from '@/features/auth/components'

function Signup() {
  return (
    <Fragment>
      <NextSeo title="Sign up" />

      <SignUpLayout />
    </Fragment>
  )
}

export default withAuthPage()(Signup)
